import { takeLatest, put, call, select } from 'redux-saga/effects';
import { CHANGE_UNLIM_SUBSCRIPTION_SAGA } from "../sagaTypes";
import { loaderAction, subscriptionFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";
import { SUBSCRIPTION_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/change_unlim_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerChangeUnlimSubscription(args) {
    const user = yield select(state => state.user);
    const currentUser = yield select(state => state.currentUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('subscription_id', args.data.subscription_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Сбрасываем данные формы
            yield put(subscriptionFormAction(SUBSCRIPTION_FORM_INITIAL));

            // Если редактировали абонемент на странице пользователя
            if (currentUser.id) {
                // Обновляем данные пользователя (с абонементами)
                yield put(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если редактировали абонемент на странице с абонементами
            else {
                // Запрашиваем изменённые абонементы
                yield put(getSubscriptionsSagaAction());
            }
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherChangeUnlimSubscription() {
    yield takeLatest(CHANGE_UNLIM_SUBSCRIPTION_SAGA, workerChangeUnlimSubscription);
}